const BlockHeading = ({ children }) => {
    return (
        <h2 className='heading block-heading'>{children}</h2>
    )
}

export default BlockHeading